module.exports = __webpack_public_path__ + "img/404img.43143cac.svg";